export default "__VITE_ASSET__DM0fO4G$__"